// extracted by mini-css-extract-plugin
export var adCard = "_ot-8";
export var adCardBorder = "_ot-5";
export var arbiterButtonIcon = "_ot-p";
export var buttonIcon = "_ot-o";
export var container = "_ot-e";
export var copyButton = "_ot-m";
export var darkGrey = "_ot-u";
export var deliveryDate = "_ot-2";
export var divider = "_ot-n";
export var editModeWrapper = "_ot-7";
export var empty = "_ot-a";
export var errorIcon = "_ot-d";
export var filledCircle = "_ot-4";
export var fulfillmentFooter = "_ot-j";
export var grey = "_ot-s";
export var header = "_ot-i";
export var headerWrapper = "_ot-h";
export var highlighted = "_ot-6";
export var historyEntry = "_ot-3";
export var mobileColumn = "_ot-v";
export var mobileColumnReverse = "_ot-w";
export var orderDetailsContainer = "_ot-g";
export var orderMetadata = "_ot-l";
export var orderMetadataWrapper = "_ot-k";
export var packagesContainer = "_ot-b";
export var product = "_ot-y";
export var productImage = "_ot-z";
export var productInfo = "_ot-x";
export var productTitle = "_ot-10";
export var strikethrough = "_ot-t";
export var tinyText = "_ot-r";
export var title = "_ot-9";
export var trackerCard = "_ot-1";
export var trackerCardWrapper = "_ot-0";
export var trackingContainer = "_ot-f";
export var trackingTitle = "_ot-c";
export var xTinyText = "_ot-q";